export default __webpack_public_path__ + "static/media/Pattern7.b2b33918.png";